import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, ButtonList, DropdownButton, DropdownButtonContext, MediaPlayer, } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import { useCallback, useMemo, useState } from 'react';
import { useMeasure } from 'react-use';
import { analytics } from 'app/utils/segment';
import { ListItemHeader } from 'components/settings/components/sections/openingHours/components/listItemHeader/listItemHeader';
import { useScheduleContext } from 'components/settings/components/sections/openingHours/views/schedule/schedule.context';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { useListItemContext } from '../../listItem.context';
import styles from '../../listItem.module.scss';
import { OverriddenItem } from '../overriddenItem/overriddenItem';
import { AnnouncementSelect } from './components/announcementSelect/announcementSelect';
import { AudioMessageModal, } from './components/audioMessageModal/audioMessageModal';
function getModalTitle({ activeModal, name, type, }) {
    switch (activeModal) {
        case 'record':
            return type === 'regular'
                ? 'Record standard audio message'
                : `Record audio message for ${name}`;
        default:
            return type === 'regular'
                ? 'Upload standard audio messsage'
                : `Upload audio message for ${name}`;
    }
}
export const AudioMessage = ({ hasConflict, name: propName, openingHours, overrideException, }) => {
    var _a;
    const { announcement, duration, id, name, next_date, opening_hour_type: openingHourType, recurring, } = openingHours;
    const [activeModal, setActiveModal] = useState(null);
    const [ref, { width }] = useMeasure();
    const shouldHideControls = useMemo(() => width <= 840, [width]);
    const { onAudioMessageChange, onAudioMessageClear, onOverriddenChange } = useListItemContext();
    const onChange = onAudioMessageChange(id);
    const onClear = onAudioMessageClear === null || onAudioMessageClear === void 0 ? void 0 : onAudioMessageClear(id);
    const { refetchAudioMessages } = useScheduleContext();
    const agentName = useAppSelector((state) => state.settings.profile.profile.name);
    const handleModalOpen = useCallback((type, toggleDropdown) => () => {
        if (type === 'record') {
            analytics.businessHoursScheduleAudioMessageOptionsMenuOptionRecordClicked({ openingHourType });
        }
        else {
            analytics.businessHoursScheduleAudioMessageOptionsMenuOptionUploadClicked({ openingHourType });
        }
        toggleDropdown === null || toggleDropdown === void 0 ? void 0 : toggleDropdown();
        setActiveModal(type || null);
    }, [openingHourType]);
    const handleUploadFinish = useCallback((file, url) => {
        onChange({ url, label: (file === null || file === void 0 ? void 0 : file.name) || '', author: agentName });
        refetchAudioMessages();
        setActiveModal(null);
    }, [agentName, refetchAudioMessages, onChange]);
    const itemName = propName || name;
    return (_jsxs("div", Object.assign({ className: styles.root, ref: ref }, { children: [overrideException ? (_jsx(OverriddenItem, { openingHours: openingHours, overrideException: overrideException, onChange: () => onOverriddenChange(openingHours) })) : (_jsxs("div", Object.assign({ className: classNames(styles.item, styles.itemAudioMessage, {
                    [styles.itemHasConflict]: hasConflict,
                }) }, { children: [_jsx(ListItemHeader, { duration: duration, hasConflict: hasConflict, name: itemName, nextDate: next_date, openingHourType: openingHourType, recurring: recurring }), _jsx(Box, Object.assign({ className: styles.announcementPicker }, { children: _jsx(AnnouncementSelect, { onSelect: onChange, placeholder: "None (standard audio message)", selectedAudio: announcement }) })), announcement && (_jsx(MediaPlayer, { className: styles.mediaPlayer, mediaFile: { src: (_a = announcement.url) !== null && _a !== void 0 ? _a : '', type: 'audio' }, controls: {
                            download: !shouldHideControls,
                            volume: !shouldHideControls,
                        } }))] }))), _jsx(DropdownButton, { buttonProps: { variant: 'tertiary' }, className: styles.dropdownButton, fixed: true, icon: "dots-h", noArrow: true, onToggle: (isOpen) => {
                    if (isOpen) {
                        analytics.businessHoursScheduleAudioMessageOptionsMenuOpened({
                            openingHourType,
                        });
                    }
                }, dropdown: _jsx(DropdownButtonContext.Consumer, { children: ({ toggleDropdown }) => (_jsxs(ButtonList, { children: [_jsx(ButtonList.Item, Object.assign({ onClick: handleModalOpen('upload', toggleDropdown) }, { children: "Upload audio message" })), _jsx(ButtonList.Item, Object.assign({ onClick: handleModalOpen('record', toggleDropdown) }, { children: "Record audio message" })), openingHourType !== 'regular' && onClear && (_jsx(ButtonList.Item, Object.assign({ isDisabled: !announcement, onClick: () => {
                                    analytics.businessHoursScheduleAudioMessageOptionsMenuOptionClearClicked({ openingHourType });
                                    onClear();
                                    toggleDropdown();
                                } }, { children: "Clear" })))] })) }) }), activeModal && (_jsx(AudioMessageModal, { modalType: activeModal, onClose: handleModalOpen(), onUploadFinish: handleUploadFinish, openingHourType: openingHourType, title: getModalTitle({
                    type: openingHourType,
                    name: itemName,
                    activeModal,
                }) }))] })));
};
